import { createContext } from "react";
import { IBeneficiaryGroup, IBeneficiaryGroupDetails } from "../../models/beneficiary-groups/response";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import { DEFAULT_FUNCTION, DEFAULT_QUERY } from "../../utils/helpers/constants";
import { ICreateBeneficiaryGroup, IUpdateBeneficiaryGroup } from "../../models/beneficiary-groups/request";

export type BeneficiaryGroupLoading =
  | "list"
  | "details"
  | "create"
  | "update"
  | "delete";

export interface IInternalState {
  loading: BeneficiaryGroupLoading[];
  list?: IBaseListingResponse<IBeneficiaryGroup>;
  details?: IBeneficiaryGroupDetails;
  query: any; 
}

export const internalState: IInternalState = {
  loading: [],
  query: DEFAULT_QUERY,
};

export interface IExternalState extends IInternalState {
  actions: {
    getData: () => void;
    getDetails: (id: number) => void;
    setDetails: (data?: IBeneficiaryGroupDetails) => void;
    createBeneficiaryGroup: (request: ICreateBeneficiaryGroup) => void;
    updateBeneficiaryGroup: (id: number, request: IUpdateBeneficiaryGroup) => void;
    deleteBeneficiaryGroup: (id: number) => void;
    setSearch: (search?: string) => void;
    setQuery: (query: any) => void;
  };
}

export const externalState: IExternalState = {
  ...internalState,
  actions: {
    getData: DEFAULT_FUNCTION,
    getDetails: DEFAULT_FUNCTION,
    setDetails: DEFAULT_FUNCTION,
    createBeneficiaryGroup: DEFAULT_FUNCTION,
    updateBeneficiaryGroup: DEFAULT_FUNCTION,
    deleteBeneficiaryGroup: DEFAULT_FUNCTION,
    setSearch: DEFAULT_FUNCTION,
    setQuery: DEFAULT_FUNCTION,
  },
};

const BeneficiaryGroupContext = createContext(externalState);

export default BeneficiaryGroupContext;
